module.exports = __webpack_public_path__ + "media/dashboard/assets/crm/food-af0f630921f696a350216e82c48cc9af.svg";